//GET_BANK_DETAILS
export const GET_ALL_BANK_ACCOUNTS_REQUEST = "GET_ALL_BANK_ACCOUNTS_REQUEST";
export const GET_ALL_BANK_ACCOUNTS_SUCCESS = "GET_ALL_BANK_ACCOUNTS_SUCCESS";
export const GET_ALL_BANK_ACCOUNTS_FAIL = "GET_ALL_BANK_ACCOUNTS_FAIL";

//CREATE_BANK_ACCOUNT
export const CREATE_BANK_ACCOUNT_REQUEST = "CREATE_BANK_ACCOUNT_REQUEST";
export const CREATE_BANK_ACCOUNT_SUCCESS = "CREATE_BANK_ACCOUNT_SUCCESS";
export const CREATE_BANK_ACCOUNT_FAIL = "CREATE_BANK_ACCOUNT_FAIL";

//EDIT_BANK_ACCOUNT
export const EDIT_BANK_ACCOUNT_REQUEST = "EDIT_BANK_ACCOUNT_REQUEST";
export const EDIT_BANK_ACCOUNT_SUCCESS = "EDIT_BANK_ACCOUNT_SUCCESS";
export const EDIT_BANK_ACCOUNT_FAIL = "EDIT_BANK_ACCOUNT_FAIL";